import React from "react";
import { useIntl } from "react-intl";
import useUserById from "src/hooks/useUserById";
import { useImpersonatedUserId } from "src/store/impersonation/useSelectors";
import { ModalData } from "./ModalContextProvider";

const useHelpFunctions = (modalData: ModalData | null) => {
  const { formatMessage: fm } = useIntl();
  const impersonatedUserId = useImpersonatedUserId();
  const impersonatedUser = useUserById(impersonatedUserId ?? null);
  const impersonatedName = (() => {
    if (impersonatedUserId === null) return null;
    if (impersonatedUser?.userName) return impersonatedUser.userName;
    return fm({ id: "common.user" }).concat(` #${impersonatedUserId}`);
  })();

  const getNameOfImpersonatedUser = () => impersonatedName;

  const getText = () => {
    let adjustedText = modalData?.text;

    if (adjustedText?.includes("_NAME_"))
      adjustedText = adjustedText?.replace(
        "_NAME_",
        getNameOfImpersonatedUser() ?? "XX YY"
      );

    return adjustedText;
  };

  return {
    getText,
  };
};

export default useHelpFunctions;
